import type {
  EventListType,
  EventSearchType,
  Product,
} from '@maestro/data-layer'
import type { Dispatch, JSX, ReactNode } from 'react'

export type ProviderType<T> = ({
  children,
  config,
}: {
  children: ReactNode
  config: T
}) => JSX.Element

export interface GlobalContextProps {
  preloadedProductData: GlobalContextData
  searchProductIndex: string
  setPreloadedProductData: Dispatch<GlobalContextData>
}

export interface GlobalContextData {
  productId?: string
  product?: Product
  productIndex?: number
  eventListProps?: EventListType
  eventSearchProps?: EventSearchType
}

export interface GlobalContextProviderProps {
  children: ReactNode
  searchProductIndex: string
}

export enum PageType {
  ACCOUNT_INFORMATION = 'account-information',
  ARTICLE = 'article',
  ARTICLE_CATEGORY = 'article-category',
  BRAND = 'brand',
  BRANDS_OVERVIEW = 'brands-overview',
  CAMPAIGN = 'campaign',
  CAMPAIGNS_OVERVIEW = 'campaigns-overview',
  CART = 'cart',
  CATEGORY = 'category',
  CHECKOUT = 'checkout',
  CHECKOUT_SUCCESS = 'checkout-success',
  FAVORITE_LIST = 'favorite-list',
  FAVORITES = 'favorites',
  FIND_STORE = 'find-store',
  FIND_STORE_LIST = 'find-store-list',
  HOMEPAGE = 'homepage',
  INVOICES = 'invoices',
  LOGIN = 'login',
  MEMBER_ADVANTAGES = 'member-advantages',
  MY_ACCOUNT = 'my-account',
  NOT_FOUND = 'not-found',
  OFFERS = 'offers',
  ORDER = 'order',
  ORDER_RETURN_OR_COMPLAINT = 'order-return-or-complaint',
  ORDERS = 'orders',
  PAGE = 'page',
  POINTS_HISTORY = 'points-history',
  PRODUCT = 'product',
  REGISTER = 'register',
  REGISTER_CHECK_EMAIL = 'register-check-email',
  REGISTER_CONFIRMATION = 'register-confirmation',
  RESET_PASSWORD = 'reset-password',
  SEARCH = 'search',
  SHOPPING_LIST = 'shopping-list',
  SHOPPING_LISTS = 'shopping-lists',
  SITEMAP_CATEGORIES = 'sitemap-categories',
  SUBSCRIPTIONS = 'subscriptions',
  WISHLIST = 'wishlist',
}
